import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState = {
  cartItems: [], // List of items in the cart
}

// Cart Slice
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    // Add item to cart
    addToCart: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload.id
      )

      if (itemIndex >= 0) {
        // Increase quantity if item exists
        state.cartItems[itemIndex].quantity += 1
      } else {
        // Add new item with quantity 1
        const tempItem = { ...action.payload, quantity: 1 }
        state.cartItems.push(tempItem)
      }
    },

    // Remove item from cart
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.id !== action.payload.id
      )
    },

    // Increase item quantity
    incrementQuantity: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload.id
      )
      if (itemIndex >= 0) {
        state.cartItems[itemIndex].quantity += 1
      }
    },

    // Decrease item quantity
    decrementQuantity: (state, action) => {
      const itemIndex = state.cartItems.findIndex(
        (item) => item.id === action.payload.id
      )
      if (state.cartItems[itemIndex].quantity > 1) {
        state.cartItems[itemIndex].quantity -= 1
      } else {
        // Remove if quantity reaches 0
        state.cartItems.splice(itemIndex, 1)
      }
    },

    // Clear Cart
    clearCart: (state) => {
      state.cartItems = []
    },
  },
})

// Export actions
export const {
  addToCart,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  clearCart,
} = cartSlice.actions

// Export reducer
export default cartSlice.reducer
